import { render, staticRenderFns } from "./Bancontact.vue?vue&type=template&id=61ff41ca&scoped=true&"
import script from "./Bancontact.vue?vue&type=script&lang=js&"
export * from "./Bancontact.vue?vue&type=script&lang=js&"
import style0 from "./Bancontact.vue?vue&type=style&index=0&id=61ff41ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ff41ca",
  null
  
)

export default component.exports